import { Button, Form } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { handleOptionsInFields } from '..';
import { DataField, FieldType } from '../../..';
import { FormLabelCustom } from '../../../styles';

interface FieldOptionsProps {
  field: FieldType
  fieldIndex: number
  formData: DataField
  setFormData: (value: React.SetStateAction<DataField>) => void  
  conditionalIndex: number
  conditionalOptionIndex: number
  isEmptyField: (fieldName: string) => boolean
  removesFieldFromTheEmptyFields: ({ fieldName, removeField }: {
    fieldName: string;
    removeField?: boolean;
}) => void
}

export function FieldOptions ({
  field,
  fieldIndex,
  formData,
  setFormData,
  conditionalIndex,
  conditionalOptionIndex,
  isEmptyField,
  removesFieldFromTheEmptyFields,
}: FieldOptionsProps) {

  const handleUpdateFieldOption = ({ 
    conditionalIndex, 
    conditionalOptionIndex, 
    fieldIndex, 
    fieldOptionIndex, 
    fieldOptionValue,
    fieldName,
   }: handleOptionsInFields) => {

    setFormData((state) => {
      const newFormData = { ...state };
      const conditionalToUpdate = newFormData.condicional_campos[conditionalIndex];
      const optionsToUpdate = conditionalToUpdate.opcoes;
      const fieldsToUpdate = optionsToUpdate[conditionalOptionIndex].lista_campos;
      const fieldToUpdate = fieldsToUpdate[fieldIndex];
      const optionsFieldToUpdate = fieldToUpdate.opcoes;
  
      const updatedOptions = optionsFieldToUpdate.map((option, i) =>
        i === fieldOptionIndex ? { ...option, [fieldName]: fieldOptionValue } : option
      );
  
      fieldToUpdate.opcoes = updatedOptions;
  
      optionsToUpdate[conditionalOptionIndex] = {
        ...optionsToUpdate[conditionalOptionIndex],
        lista_campos: [...fieldsToUpdate.slice(0, fieldIndex), fieldToUpdate, ...fieldsToUpdate.slice(fieldIndex + 1)],
      };
  
      conditionalToUpdate.opcoes = optionsToUpdate;
      newFormData.condicional_campos[conditionalIndex] = conditionalToUpdate;
  
      return newFormData;
    });
  };

  const handleRemoveOptionInConditionalFields = ({conditionalIndex, conditionalOptionIndex, fieldIndex, fieldOptionIndex}: handleOptionsInFields) => {
    let newFormData = { ...formData };
    let conditionalToUpdate = newFormData.condicional_campos[conditionalIndex];
    let optionsToUpdate = conditionalToUpdate.opcoes;
    let fieldsToUpdate = optionsToUpdate[conditionalOptionIndex].lista_campos;
    let fieldToUpdate = fieldsToUpdate[fieldIndex];
    let optionsFieldToUpdate = fieldToUpdate.opcoes;

    const updatedOptions = optionsFieldToUpdate.filter((_, i) => i !== fieldOptionIndex);

    fieldToUpdate.opcoes = updatedOptions;

    optionsToUpdate[conditionalOptionIndex] = {
      ...optionsToUpdate[conditionalOptionIndex],
      lista_campos: [...fieldsToUpdate.slice(0, fieldIndex), fieldToUpdate, ...fieldsToUpdate.slice(fieldIndex + 1)],
    };

    conditionalToUpdate.opcoes = optionsToUpdate;
    newFormData.condicional_campos[conditionalIndex] = conditionalToUpdate;

    setFormData(newFormData);
  }

  return (
    <>
      {(field.opcoes && field.opcoes.length > 0) && field.opcoes.map((fieldOption, fieldOptionIndex) => (
        <div key={fieldOption.id} className='row col-md-12'>
          <Form.Group 
              style={{ maxWidth: 80}}
              className="col-md-2">
            <FormLabelCustom>Opção</FormLabelCustom>
            <Form.Control
              placeholder="Opção"
              readOnly
              style={{ maxWidth: 40, aspectRatio: '1'}}
              value={fieldOptionIndex + 1}
            />
          </Form.Group>
          <Form.Group className="mb-3 col-md-5">
            <FormLabelCustom required>Valor</FormLabelCustom>
            <Form.Control
              placeholder="Digite o valor da opção"
              value={fieldOption.resposta}
              isInvalid={isEmptyField(`fieldOption.${fieldOption.id}`)}
              required
              onChange={(event) => {
                handleUpdateFieldOption({
                  conditionalIndex,
                  conditionalOptionIndex,
                  fieldIndex,
                  fieldOptionIndex,
                  fieldOptionValue: event.target.value,
                  fieldName: 'resposta'
                });
                removesFieldFromTheEmptyFields({
                  fieldName: `fieldOption.${fieldOption.id}`, 
                  removeField: !!event.target.value
                })
              }}
            />
            {isEmptyField(`fieldOption.${fieldOption.id}`) && 
              <Form.Control.Feedback type="invalid">
                Campo obrigatório
              </Form.Control.Feedback>
            }
          </Form.Group>
          {field.opcoes.length >= 2 && (
            <div className="mt-4 pt-2 col-md-1 col-sm-12 text-center">
              <Button
                variant="text"
                className="border"
                title="Remover está opção da lista"
                onClick={() => {
                  handleRemoveOptionInConditionalFields({
                    conditionalIndex,
                    conditionalOptionIndex,
                    fieldIndex,
                    fieldOptionIndex
                  })
                }}
              >
                <FaTrash/>
            </Button>
          </div>
          )}
        </div>
       ))}
    </>
  )
}